import {
  CheckIcon,
  CodescanCheckmarkIcon,
  CodespacesIcon,
  DependabotIcon,
  FileAddedIcon,
  FileDirectoryIcon,
  FileDiffIcon,
  GitPullRequestIcon,
  GlobeIcon,
  LightBulbIcon,
  McpIcon,
  SearchIcon,
  TasklistIcon,
  TerminalIcon,
  ViewFilesIcon,
} from '@primer/octicons-react'
import {SlackIcon} from '@github-ui/custom-icons/SlackIcon'
import type {ToolName} from '../../../types/session'
import {GITHUB_CODE_SEARCH_GROUP_KEY, TOOL_NAMES} from '../../../constants/tool-names'

export function getToolIcon(toolName: ToolName = '', mcpToolNameMappings?: Record<string, string>) {
  switch (toolName) {
    case TOOL_NAMES.SLACK_POST_MESSAGE:
    case TOOL_NAMES.SLACK_REACT:
    case TOOL_NAMES.SLACK_UNREACT:
    case TOOL_NAMES.SLACK_UPLOAD_FILE:
    case TOOL_NAMES.SLACK_SWITCH_REPO:
    case TOOL_NAMES.SLACK_CREATE_CODE_CHANNEL:
    case TOOL_NAMES.SLACK_SET_CODE_CHANNEL_CONTEXT:
    case TOOL_NAMES.SLACK_SET_CODE_CHANNEL_DIFF:
    case TOOL_NAMES.SLACK_SET_CODE_CHANNEL_HTML:
    case TOOL_NAMES.SLACK_ARCHIVE_CODE_CHANNEL:
      return <SlackIcon />
    case TOOL_NAMES.APPLY_PATCH:
      return <FileDiffIcon className="fgColor-attention" aria-label="File edit: " />
    case TOOL_NAMES.BASH:
    case TOOL_NAMES.LOCAL_SHELL:
    case TOOL_NAMES.WRITE_BASH:
    case TOOL_NAMES.READ_BASH:
    case TOOL_NAMES.STOP_BASH:
    case TOOL_NAMES.LIST_BASH:
    case TOOL_NAMES.ASYNC_BASH:
    case TOOL_NAMES.READ_ASYNC_BASH:
    case TOOL_NAMES.STOP_ASYNC_BASH:
    case TOOL_NAMES.POWERSHELL:
    case TOOL_NAMES.WRITE_POWERSHELL:
    case TOOL_NAMES.READ_POWERSHELL:
    case TOOL_NAMES.STOP_POWERSHELL:
    case TOOL_NAMES.LIST_POWERSHELL:
      return <TerminalIcon aria-label="CLI output: " />
    case TOOL_NAMES.THINK:
      return <LightBulbIcon aria-label="Copilot thought: " />
    case TOOL_NAMES.STR_REPLACE_EDITOR:
    case TOOL_NAMES.STR_REPLACE:
    case TOOL_NAMES.EDIT:
      return <FileDiffIcon className="fgColor-attention" aria-label="File edit: " />
    case TOOL_NAMES.CREATE:
      return <FileAddedIcon className="fgColor-success" aria-label="File creation: " />
    case TOOL_NAMES.VIEW:
      return <ViewFilesIcon aria-label="View file: " />
    case TOOL_NAMES.GREP:
    case TOOL_NAMES.RG:
    case TOOL_NAMES.SEARCH_CODE_SUBAGENT:
      return <SearchIcon aria-label="Search: " />
    case GITHUB_CODE_SEARCH_GROUP_KEY:
      return <SearchIcon aria-hidden="true" />
    case TOOL_NAMES.WEB_SEARCH:
      return <SearchIcon aria-label="Web search: " />
    case TOOL_NAMES.WEB_FETCH:
      return <GlobeIcon aria-label="Web fetch: " />
    case TOOL_NAMES.GLOB:
      return <FileDirectoryIcon aria-label="Find files: " />
    case TOOL_NAMES.RUN_CUSTOM_SETUP_STEP:
    case TOOL_NAMES.RUN_SETUP:
      return <CodespacesIcon aria-label="Custom setup run: " />
    case TOOL_NAMES.PROPOSE_WORK:
      return <TasklistIcon aria-label="Propose work: " />
    case TOOL_NAMES.CODE_REVIEW:
      return <CodescanCheckmarkIcon aria-label="Code review: " />
    case TOOL_NAMES.CODEQL_CHECKER:
      return <CodescanCheckmarkIcon aria-label="CodeQL scan: " />
    case TOOL_NAMES.CREATE_PULL_REQUEST:
      return <GitPullRequestIcon aria-label="Create pull request: " />
    case TOOL_NAMES.PARALLEL_VALIDATION:
      return <CodescanCheckmarkIcon aria-label="Parallel validation: " />
    case TOOL_NAMES.TASK_COMPLETE:
      return <CheckIcon className="fgColor-success" aria-label="Task complete" />
    case TOOL_NAMES.READ_AGENT:
      return <DependabotIcon aria-label="Read agent: " />
    case TOOL_NAMES.WRITE_AGENT:
      return <DependabotIcon aria-label="Message agent: " />
    case TOOL_NAMES.LIST_AGENTS:
      return <DependabotIcon aria-label="List agents: " />
    case TOOL_NAMES.REPORT_PROGRESS:
    case TOOL_NAMES.REPLY_TO_COMMENT:
      return <TerminalIcon aria-label="Tool output: " />
    default:
      if (mcpToolNameMappings && Object.prototype.hasOwnProperty.call(mcpToolNameMappings, toolName)) {
        return <McpIcon aria-label="MCP tool: " />
      }
      return <TerminalIcon aria-label="Tool output: " />
  }
}
